import {
  Alert,
  AlertTitle,
  Backdrop,
  Button,
  Card,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  Icon,
  IconButton,
  InputLabel,
  ListItem,
  MenuItem,
  Select,
  Snackbar,
  Typography,
} from "@mui/material";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
import MDInput from "theme/components/MDInput";
// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import axios from "axios.js";
import usePageTitle from "app/pageTitle";
import AppConfig from "appConfig";
import { useAppLocation } from "agent_location_context";
import { useAwaitDialog } from "app/components/status_dialog";
import DialerDrawer from "./components/launch_dialer";
import CallHistoryPage from "./components/history";

function CallCenterPage() {
  const pageTitle = `Call Center`;
  usePageTitle(pageTitle);
  const navigate = useNavigate();
  const { ref } = useParams();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const { applocation, permissionStatus, updateAppLocation } = useAppLocation();
  const statusDialog = useAwaitDialog();

  const [pageLoaded, setPageLoaded] = useState(false);
  const [refreshPage, setRefreshPage] = useState(false);

  const [callCenter, setCallCenter] = useState({});
  const [stats, setStats] = useState({});
  const [performance, setPerformance] = useState(null);
  const [contact, setContact] = useState(null);
  const [dialerToken, setDialerToken] = useState(null);
  const [openDialerLauncher, setOpenDialerLauncher] = useState(false);

  const [history, setHistory] = useState([]);
  const [openHistoryDialog, setOpenHistoryDialog] = useState(false);

  const [callOutcomes, setCallOutcomes] = useState([]);
  const [selectedOutcome, setSelectedOutcome] = useState(null);
  const [openOutcomeDialog, setOpenOutcomeDialog] = useState(false);

  const [widgetToken, setWidgetToken] = useState(null);
  const [showExtensionDialog, setShowExtensionDialog] = useState(false);
  const isChrome =
    /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`agents/call_centers/${ref}/fetch.json`)
        .then((result) => {
          setShowLoading(false);
          if (result.data.status === "success") {
            setCallCenter(result.data.data.center);
            setStats(result.data.data.stats);
            setPerformance(result.data.data.performance);
            setCallOutcomes(result.data.data.call_outcomes);

            setWidgetToken(
              btoa(
                `${result.data.data.center.reference}:${result.data.data.center.agent_ref}`,
              ),
            );

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine
                ? ""
                : "Make sure you have an active internet connection"
            }`,
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function initDialer() {
    setShowLoading(true);
    await axios
      .get(`agents/call_centers/${ref}/dialer.json`)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setDialerToken(result.data.data);

          setPageLoaded(true);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine
              ? ""
              : "Make sure you have an active internet connection"
          }`,
        );
        setOpen(true);
      });
  }

  async function getFreshToken() {
    let token = null;
    let expires = null;

    setShowLoading(true);
    await axios
      .get(`agents/call_centers/${ref}/dialer.json`)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          token = result.data.data.token;
          expires = result.data.data.expires;
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine
              ? ""
              : "Make sure you have an active internet connection"
          }`,
        );
        setOpen(true);
      });

    return { token, expires };
  }

  async function getContact() {
    setShowLoading(true);
    await axios
      .get(`agents/call_centers/${ref}/contact.json`)
      .then((result) => {
        setShowLoading(false);
        // console.log(result.data.data);
        if (result.data.status === "success") {
          setContact(result.data.data.contact);
          setOpenDialerLauncher(true);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine
              ? ""
              : "Make sure you have an active internet connection"
          }`,
        );
        setOpen(true);
      });
  }

  async function getHistroy() {
    setShowLoading(true);
    await axios
      .get(`agents/call_centers/${ref}/history.json`)
      .then((result) => {
        setShowLoading(false);
        // console.log(result.data.data);
        if (result.data.status === "success") {
          setHistory(result.data.data.history);
          setOpenHistoryDialog(true);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine
              ? ""
              : "Make sure you have an active internet connection"
          }`,
        );
        setOpen(true);
      });
  }

  async function submitOutcome() {
    if (!contact?.reference) {
      setSeverity("error");
      setErrMsg("No contact found.");
      setOpen(true);
      return false;
    }

    if (selectedOutcome === null) {
      setSeverity("error");
      setErrMsg("Call outcome is required.");
      setOpen(true);
      return false;
    }

    setOpenOutcomeDialog(false);
    setShowLoading(true);

    const json = {
      contact: contact.reference,
      outcome: selectedOutcome,
      lat: applocation?.lat,
      lng: applocation?.lng,
    };

    await axios
      .post("agents/call_centers/call/outcome.json", json)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(
            result.data.data.message,
            "success",
            "Success!",
          );
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Failed");
        }
      })
      .catch(async () => {
        setShowLoading(false);
        let err = `Unable to complete request. ${
          navigator.onLine
            ? ""
            : "Make sure you have an active internet connection"
        }`;
        await statusDialog.show(err, "error", "Failed");
      });

    setContact(null);
    setOpenDialerLauncher(false);
  }

  const [extensionInstalled, setExtensionInstalled] = useState(false);

  useEffect(() => {
    function handleMessage(event) {
      if (event.data.type === "LADDAR_VOICE_EXTENSION_FOUND") {
        setExtensionInstalled(true);
      }
    }

    window.addEventListener("message", handleMessage);

    setTimeout(() => {
      window.postMessage(
        {
          type: "LADDAR_VOICE_CHECK_EXTENSION",
        },
        "*",
      );
    }, 300);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  function launchExtension() {
    if (!widgetToken) {
      return;
    }

    window.postMessage(
      {
        type: "LADDAR_VOICE_LAUNCH_DIALER",
        token: widgetToken,
      },
      "*",
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {widgetToken && (
        <Dialog open={showExtensionDialog} fullWidth maxWidth="xs">
          <DialogTitle>
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <MDBox>
                <MDTypography variant="h6" fontWeight="bold">Chrome Dialer Widget</MDTypography>
              </MDBox>
              <MDBox>
                <MDButton
                  color="dark"
                  variant="outlined"
                  onClick={() => {
                    setShowExtensionDialog(false);
                  }}
                  iconOnly
                  circular
                  size="small"
                >
                  <Icon>close</Icon>
                </MDButton>
              </MDBox>
            </MDBox>
          </DialogTitle>
          <DialogContent>
            <MDBox mt={1}>
              <Typography variant="body2" fontSize={14} fontWeight={400}>
                Access Token
              </Typography>
              <MDBox
                mt={1}
                px={1.5}
                py={1}
                borderRadius="10px"
                sx={{
                  background: "#f1f5f9",
                  border: "1px solid #e2e8f0",
                  fontFamily: "monospace",
                  fontSize: "12px",
                  color: "#64748b",
                  wordBreak: "break-all",
                  overflowWrap: "break-word",
                  lineHeight: 1.6,
                }}
              >
                {widgetToken}
              </MDBox>
              <MDBox mt={2} mb={3}>
                <MDButton
                  color="dark"
                  variant="outlined"
                  onClick={async () => {
                    await navigator.clipboard.writeText(widgetToken);

                    setSeverity("success");
                    setErrMsg("Token copied");
                    setOpen(true);
                  }}
                  size="small"
                  startIcon={<Icon>content_copy</Icon>}
                >
                  Copy Token
                </MDButton>
                {!isChrome && (
                  <MDBox mt={3}>
                    <Alert severity="warning">
                      <AlertTitle fontSize={13}>
                        Dialer Widget cannot be installed on this browser.
                      </AlertTitle>
                      <MDTypography variant="body2" fontSize={12}>
                        To use the browser dialer widget, install and use a
                        supported desktop browser such as Google Chrome,
                        Microsoft Edge, Brave, Opera, Arc, or other
                        Chromium-based browsers on your desktop or laptop
                        computer.
                      </MDTypography>
                    </Alert>
                  </MDBox>
                )}
              </MDBox>
            </MDBox>
          </DialogContent>
          <DialogActions>
            {/* <MDButton
              color="primary"
              variant="contained"
              href="https://chromewebstore.google.com/detail/laddar-voice/ooijdbaabpplfgamcfjkgoabeegggfac"
              target="_blank"
              startIcon={<Icon>install_desktop</Icon>}
            >
              Install
            </MDButton> */}
            {extensionInstalled ? (
              <MDButton
                color="primary"
                variant="contained"
                startIcon={<Icon>launch</Icon>}
                onClick={() => launchExtension()}
              >
                Launch
              </MDButton>
            ) : (
              <>
                <MDButton
                  color="primary"
                  variant="outlined"
                  href="https://microsoftedge.microsoft.com/addons/detail/dkenmfnpnmhgojkpcipndjgopbabgeoj"
                  target="_blank"
                  startIcon={<Icon>install_desktop</Icon>}
                >
                  Edge Install
                </MDButton>
                &nbsp;&nbsp;
                <MDButton
                  color="primary"
                  variant="contained"
                  href="https://chromewebstore.google.com/detail/laddar-voice/ooijdbaabpplfgamcfjkgoabeegggfac"
                  target="_blank"
                  startIcon={<Icon>install_desktop</Icon>}
                >
                  Chrome Install
                </MDButton>
              </>
            )}
          </DialogActions>
        </Dialog>
      )}

      <Dialog open={openOutcomeDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Log Call Outcome</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox>
            <MDBox mt={2}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Call Outcome</InputLabel>
                <Select
                  label="Call Outcome"
                  onChange={(e) => {
                    setSelectedOutcome(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {
                    // --> Notice below changes
                    callOutcomes.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      callOutcomes.map((record) => (
                        <MenuItem value={`${record.reference}`}>
                          {record.title}
                        </MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            color="primary"
            variant="contained"
            onClick={() => {
              submitOutcome();
            }}
          >
            Submit
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox mt={2} mb={5}>
        <MDBox mb={1} display="flex" justifyContent="space-between">
          <MDBox>
            <Button
              color="dark"
              startIcon={<Icon>west</Icon>}
              onClick={() => navigate("/call-centers")}
            >
              Back
            </Button>
          </MDBox>
          <MDBox mt={0.5} pr={1}>
            <MDButton
              color="dark"
              variant="outlined"
              size="small"
              iconOnly
              onClick={() => setRefreshPage(!refreshPage)}
            >
              <Icon>refresh</Icon>
            </MDButton>
            {/* &nbsp;&nbsp;
            <MDButton
              iconOnly
              color="dark"
              variant="outlined"
              size="small"
              onClick={() => getHistroy()}
            >
              <Icon>list</Icon>
            </MDButton> */}
          </MDBox>
        </MDBox>
        {pageLoaded && (
          <MDBox>
            <MDBox>
              <Card>
                <MDBox p={2}>
                  <MDBox>
                    <ListItem>
                      <MDBox
                        width="100%"
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <MDBox mt={-1}>
                          <MDTypography variant="h6">
                            {callCenter.title}
                          </MDTypography>
                          <MDTypography
                            mt={1}
                            fontSize={12}
                            color="text.secondary"
                          >
                            {callCenter.account.name}
                          </MDTypography>
                        </MDBox>

                        <MDBox>
                          <MDBox>
                            <Icon>support_agent</Icon>
                          </MDBox>
                          <MDBox>
                            <img
                              src={`${AppConfig.api_media_url}${callCenter.account.icon}`}
                              alt=""
                              width="18px"
                            />
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </ListItem>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
            <MDBox mt={3}>
              <Grid container spacing={2}>
                <Grid item xs={6} md={6} lg={6}>
                  <MDBox>
                    <Card>
                      <MDBox p={2} align="center">
                        <MDTypography variant="h6" fontSize={36}>
                          {stats.outgoing.calls}
                        </MDTypography>
                        <MDTypography
                          variant="h6"
                          fontSize={13}
                          fontWeight="light"
                        >
                          Calls
                          <br />
                          Made
                        </MDTypography>
                      </MDBox>
                    </Card>
                  </MDBox>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <MDBox>
                    <Card>
                      <MDBox p={2} align="center">
                        <MDTypography variant="h6" fontSize={36}>
                          {stats.incoming.calls}
                        </MDTypography>
                        <MDTypography
                          variant="h6"
                          fontSize={13}
                          fontWeight="light"
                        >
                          Calls
                          <br />
                          Received
                        </MDTypography>
                      </MDBox>
                    </Card>
                  </MDBox>
                </Grid>
              </Grid>
            </MDBox>
            {performance && (
              <MDBox mt={3}>
                <Card>
                  <MDBox p={2}>
                    {/* <MDTypography mt={-1} mb={2} align="center" variant="h6" fontSize={14}>My Performance</MDTypography> */}
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <MDBox
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          mb={0}
                        >
                          <MDBox position="relative" display="inline-flex">
                            {/* GREY BACKGROUND RING */}
                            <CircularProgress
                              variant="determinate"
                              value={100}
                              size={100}
                              thickness={3.6}
                              sx={{
                                color: "#e5e7eb",
                                position: "absolute",
                                left: 0,
                              }}
                            />

                            {/* ACTIVE PROGRESS */}
                            <CircularProgress
                              variant="determinate"
                              value={performance.avg_score}
                              size={100}
                              thickness={3.6}
                              sx={{
                                color: "#163d7a",
                              }}
                            />

                            {/* CENTER CONTENT */}
                            <MDBox
                              top={0}
                              left={0}
                              bottom={0}
                              right={0}
                              position="absolute"
                              display="flex"
                              flexDirection="column"
                              alignItems="center"
                              justifyContent="center"
                            >
                              <MDTypography
                                variant="h3"
                                fontWeight="bold"
                                fontSize={20}
                              >
                                {performance.avg_score.toFixed(0)}%
                              </MDTypography>

                              <MDTypography
                                variant="caption"
                                color="text"
                                fontSize={11}
                              >
                                Overall
                              </MDTypography>
                            </MDBox>
                          </MDBox>
                        </MDBox>
                      </Grid>

                      {/* PROFESSIONALISM */}
                      <Grid item xs={12}>
                        <Card
                          sx={{
                            backgroundColor: "#ede9fe",
                            borderRadius: 3,
                            boxShadow: "none",
                            height: "100%",
                          }}
                        >
                          <MDBox
                            p={1}
                            textAlign="center"
                            display="flex"
                            flexDirection="column"
                            justifyContent="center"
                            alignItems="center"
                            height="100%"
                          >
                            <Icon
                              sx={{
                                color: "#7c3aed",
                                mb: 1,
                                fontSize: 22,
                              }}
                            >
                              workspace_premium
                            </Icon>

                            <MDTypography
                              variant="button"
                              fontWeight="bold"
                              fontSize={14}
                              sx={{
                                color: "#7c3aed",
                              }}
                            >
                              Professionalism
                            </MDTypography>

                            <MDTypography
                              variant="h4"
                              fontWeight="bold"
                              mt={0.5}
                              fontSize={20}
                            >
                              {performance.avg_professionalism.toFixed(0)}%
                            </MDTypography>
                          </MDBox>
                        </Card>
                      </Grid>

                      {[
                        {
                          label: "Control",
                          value: performance.avg_control,
                          color: "#e9f8ee",
                          text: "#16a34a",
                          icon: "support_agent",
                        },
                        {
                          label: "Clarity",
                          value: performance.avg_clarity,
                          color: "#e8f0ff",
                          text: "#2563eb",
                          icon: "record_voice_over",
                        },
                        {
                          label: "Empathy",
                          value: performance.avg_empathy,
                          color: "#fce7ef",
                          text: "#e11d48",
                          icon: "favorite",
                        },
                        {
                          label: "Listening",
                          value: performance.avg_listening,
                          color: "#fdf4d7",
                          text: "#d97706",
                          icon: "hearing",
                        },
                      ].map((item) => (
                        <Grid item xs={6} key={item.label}>
                          <Card
                            sx={{
                              backgroundColor: item.color,
                              borderRadius: 3,
                              boxShadow: "none",
                              height: "100%",
                            }}
                          >
                            <MDBox
                              p={1}
                              textAlign="center"
                              display="flex"
                              flexDirection="column"
                              justifyContent="center"
                              alignItems="center"
                            >
                              <Icon
                                sx={{
                                  color: item.text,
                                  mb: 0.5,
                                  fontSize: 22,
                                }}
                              >
                                {item.icon}
                              </Icon>

                              <MDTypography
                                variant="button"
                                fontWeight="bold"
                                fontSize={13}
                                sx={{
                                  color: item.text,
                                }}
                              >
                                {item.label}
                              </MDTypography>

                              <MDTypography
                                variant="h4"
                                fontWeight="bold"
                                mt={0.5}
                                fontSize={20}
                              >
                                {item.value.toFixed(0)}%
                              </MDTypography>
                            </MDBox>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  </MDBox>
                </Card>
              </MDBox>
            )}
            <MDBox mt={5}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6} lg={6}>
                  <MDButton
                    variant="contained"
                    color="primary"
                    fullWidth
                    size="large"
                    startIcon={<Icon>phone</Icon>}
                    onClick={() => {
                      navigate(`/call-centers/dialer/${ref}`);
                    }}
                  >
                    Open Dialer
                  </MDButton>
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <MDButton
                    variant="outlined"
                    color="primary"
                    fullWidth
                    size="large"
                    startIcon={<Icon>launch</Icon>}
                    onClick={() => setShowExtensionDialog(true)}
                  >
                    Dialer Widget
                  </MDButton>
                </Grid>
              </Grid>
            </MDBox>
            {/* <MDBox mt={5}>
              <MDBox>
                <MDButton
                  variant="contained"
                  color="primary"
                  fullWidth
                  size="large"
                  startIcon={<Icon>call</Icon>}
                  onClick={() => {
                    setContact(null);
                    getContact();
                  }}
                >
                  Call Contact
                </MDButton>
              </MDBox>
            </MDBox>
            <MDBox mt={5}>
              <DialerDrawer
                open={openDialerLauncher}
                onClose={() => setOpenDialerLauncher(false)}
                onIncomingCall={() => setOpenDialerLauncher(true)}
                agentRef={ref}
                contact={contact}
                onCallCompleted={(contact) => {
                  if (callOutcomes.length <= 0) {
                    return;
                  }
                  setOpenOutcomeDialog(true);
                }}
              />
              <CallHistoryPage
                open={openHistoryDialog}
                onClose={() => setOpenHistoryDialog(false)}
                calls={history}
                onSelectContact={(contact) => {
                  setContact(contact);
                  setOpenDialerLauncher(true);
                }}
              />
            </MDBox> */}
            <CallHistoryPage
              open={openHistoryDialog}
              onClose={() => setOpenHistoryDialog(false)}
              calls={history}
              onSelectContact={(contact) => {
                setContact(contact);
                setOpenDialerLauncher(true);
              }}
            />
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CallCenterPage;
